import classnames from 'classnames';
import * as React from 'react';
import { useEffect, useState, FC } from 'react';
import { useWindowScroll } from 'react-use';
import { useDeviceClassification } from 'utils';

type TFigCaptionProps = {
    Alt: string,
    mobile?: boolean
}

export const FigCaption: FC<TFigCaptionProps> = ({ Alt, mobile }) => {
    const { y } = useWindowScroll();
    const [bodyScrolled, setBodyScrolled] = useState<boolean>(false);
    const { isDesktop } = useDeviceClassification();


    useEffect(() => {
        if (y > 50) {
            !bodyScrolled && setBodyScrolled(true)
        } else if (y < 50) {
            bodyScrolled && setBodyScrolled(false)
        }
    }, [y]);

    return !isDesktop ? <> <div className={classnames("mobileFigCaption", { hidden: bodyScrolled })}>
        <p>{Alt}</p>
    </div>
    </>
        : <>
            <figcaption className="hero-figcaption" style={{ bottom: 0, opacity: bodyScrolled ? 0 : 1 }}><span>{Alt}</span></figcaption>
        </>

};